import Vue from 'vue';
import Router from 'vue-router';

// utils
import r from '~/utils/render-utils';

const NotFound = () => import(/* webpackChunkName: 'notfound' */ '~/pages/NotFound');

// YIR 2019
const YIR2019 = () => import(/* webpackChunkName: 'yir' */ '~/pages/YIR2019');
const YIR2019Index = () => import(/* webpackChunkName: 'yir' */ '~/pages/YIR2019/index');
const YIR2019Sections = () => import(/* webpackChunkName: 'yir' */ '~/pages/YIR2019/sections');
const YIR2019Reward = () => import(/* webpackChunkName: 'yir' */ '~/pages/YIR2019/rewards');
const YIR2019Share = () => import(/* webpackChunkName: 'yir-share' */ '~/pages/YIR2019/share');
const YIR2019Off = () => import(/* webpackChunkName: 'yir-off' */ '~/pages/YIR2019/off');

const SpinWin = () => import(/* webpackChunkName: 'spinwin' */ '~/pages/SpinWin');
const SpinWinIndex = () => import(/* webpackChunkName: 'spnwin' */ '~/pages/SpinWin/index');

const MitraBantuan = () => import(/* webpackChunkName: 'spnwin' */ '~/pages/MitraBantuan');
const MitraBantuanIndex = () => import(/* webpackChunkName: 'spnwin' */ '~/pages/MitraBantuan/index');

// Mitra Chat
const MitraChat = () => import(/* webpackChunkName: 'mitra-chat' */ '~/pages/MitraChat');
const MitraChatIndex = () => import(/* webpackChunkName: 'mitra-chat-index' */ '~/pages/MitraChat/index');
const MitraChatNew = () => import(/* webpackChunkName: 'mitra-chat-new' */ '~/pages/MitraChat/new');
const MitraChatMaintenance = () =>
  import(/* webpackChunkName: 'mitra-chat-maintenance' */ '~/pages/MitraChat/maintenance');
const MitraChatInboxIndex = () =>
  import(/* webpackChunkName: 'mitra-chat-inbox-index' */ '~/pages/MitraChat/inbox/index');
const MitraChatInboxDetail = () =>
  import(/* webpackChunkName: 'mitra-chat-inbox-detail' */ '~/pages/MitraChat/inbox/detail');
const MitraChatCheckSessionIndex = () =>
  import(/* webpackChunkName: 'mitra-chat-check-session-index' */ '~/pages/MitraChat/session/index');


// Mitra Chat GPT
const MitraChatGptIndex = () => import(/* webpackChunkName: 'mitra-chat-gpt-index' */ '~/pages/MitraChat/gpt/index');

// Mitra Chat Messaging
const MitraChatMessagingIndex = () => import(/* webpackChunkName: 'mitra-chat-messaging-index' */ '~/pages/MitraChat/messaging/index');

// Mitra Peduli
const MitraPeduli = () => import(/* webpackChunkName: 'mitra-peduli' */ '~/pages/MitraPeduli');
const MitraPeduliIndex = () => import(/* webpackChunkName: 'mitra-peduli' */ '~/pages/MitraPeduli/index');
const MitraPeduliForm = () => import(/* webpackChunkName: 'mitra-peduli' */ '~/pages/MitraPeduli/form');
const MitraPeduliDetail = () => import(/* webpackChunkName: 'mitra-peduli' */ '~/pages/MitraPeduli/detail');
const MitraPeduliTnc = () => import(/* webpackChunkName: 'mitra-peduli' */ '~/pages/MitraPeduli/tnc');

// Ulasan Belanja
const UlasanBelanja = () => import(/* webpackChunkName: 'mitra-peduli' */ '~/pages/UlasanBelanja');

// Puzzle Miliarder
const MitraPuzzleMiliarder = () => import(/* webpackChunkName: 'mitra-puzzle-miliarder' */ '~/pages/PuzzleMiliarder');
const MitraPuzzleMiliarderIndex = () =>
  import(/* webpackChunkName: 'mitra-puzzle-miliarder' */ '~/pages/PuzzleMiliarder/index');
const MitraPuzzleMiliarderTnc = () =>
  import(/* webpackChunkName: 'mitra-puzzle-miliarder' */ '~/pages/PuzzleMiliarder/tnc');
const MitraPuzzleMiliarderOnboarding = () =>
  import(/* webpackChunkName: 'mitra-puzzle-miliarder' */ '~/pages/PuzzleMiliarder/onboarding');
const MitraPuzzleMiliarderHistory = () =>
  import(/* webpackChunkName: 'mitra-puzzle-miliarder' */ '~/pages/PuzzleMiliarder/history');

// FAQ
const FAQ = () => import(/* webpackChunkName: 'FAQ' */ '~/pages/FAQ');

// UbahNomor
const UbahNomor = () => import(/* webpackChunkName: 'ubah-nomor' */ '~/pages/UbahNomor');
const UbahNomorIndex = () => import(/* webpackChunkName: 'ubah-nomor' */ '~/pages/UbahNomor/index');
const VerificationForm = () => import(/* webpackChunkName: 'ubah-nomor' */ '~/pages/UbahNomor/VerificationForm');
const OTPVerificationForm = () => import(/* webpackChunkName: 'ubah-nomor' */ '~/pages/UbahNomor/OtpVerification');
const CameraOverlayCapture = () =>
  import(/* webpackChunkName: 'ubah-nomor' */ '~/pages/UbahNomor/partials/CameraOverlay');
const CurrentNumberConfirmation = () =>
  import(/* webpackChunkName: 'ubah-nomor' */ '~/pages/UbahNomor/UbahNomorMandiri/CurrentNumberConfirmation');
const PhoneNumberVerification = () =>
  import(/* webpackChunkName: 'ubah-nomor' */ '~/pages/UbahNomor/UbahNomorMandiri/PhoneNumberVerification');
const InputNewNumber = () =>
  import(/* webpackChunkName: 'ubah-nomor' */ '~/pages/UbahNomor/UbahNomorMandiri/InputNewNumber');
const UnbindingConsent = () => import(/* webpackChunkName: 'ubah-nomor' */ '~/pages/UbahNomor/UnbindingConsent');

// Mitra B2B
const B2B = () => import(/* webpackChunkName: 'b2b' */ '~/pages/B2B');
const B2BIndex = () => import(/* webpackChunkName: 'b2b-index' */ '~/pages/B2B/Index');
const B2BBantuan = () => import(/* webpackChunkName: 'b2b-bantuan' */ '~/pages/B2B/Bantuan');
const B2BProductDetail = () => import(/* webpackChunkName: 'b2b-product-detail' */ '~/pages/B2B/products/_id');

Vue.use(Router);

const routes = [
  {
    path: '/404',
    component: r(NotFound),
    name: 'not_found',
  },
  {
    path: '/mitra-chat/',
    component: r(MitraChat),
    children: [
      {
        path: '',
        component: r(MitraChatIndex),
        name: 'mitra_chat_index',
      },
      {
        path: 'new',
        component: r(MitraChatNew),
        name: 'mitra_chat_new',
      },
      {
        path: 'maintenance',
        component: r(MitraChatMaintenance),
        name: 'mitra_chat_maintenance',
      },
      {
        path: 'inbox',
        component: r(MitraChatInboxIndex),
        name: 'mitra_chat_inbox_index',
      },
      {
        path: 'inbox/:id',
        component: r(MitraChatInboxDetail),
        name: 'mitra_chat_inbox_detail',
      },
      {
        path: 'gpt',
        component: r(MitraChatGptIndex),
        name: 'mitra_chat_gpt_index',
      },
      {
        path: 'messaging',
        component: r(MitraChatMessagingIndex),
        name: 'mitra_chat_messaging_index',
      },
      {
        path: 'check-session',
        component: r(MitraChatCheckSessionIndex),
        name: 'mitra_check_session_index'
      }
    ],
  },
  {
    path: '/mitra-bantuan/',
    component: r(MitraBantuan),
    children: [
      {
        path: '',
        component: r(MitraBantuanIndex),
        name: 'mitra_bantuan_index'
      }
    ],
  },
  {
    path: '/mitra-peduli/',
    component: r(MitraPeduli),
    children: [
      {
        path: '',
        component: r(MitraPeduliIndex),
        name: 'mitra_peduli_index',
      },
      {
        path: 'form',
        component: r(MitraPeduliForm),
        name: 'mitra_peduli_form',
      },
      {
        path: 'tnc',
        component: r(MitraPeduliTnc),
        name: 'mitra_peduli_tnc',
      },
      {
        path: ':id',
        component: r(MitraPeduliDetail),
        name: 'mitra_peduli_detail',
      },
    ],
  },
  {
    path: '/syukuran/',
    component: r(YIR2019),
    children: [
      {
        path: '',
        component: r(YIR2019Index),
        name: 'yir_2019_index',
      },
      {
        path: 'sections',
        component: r(YIR2019Sections),
        name: 'yir_2019_sections',
      },
      {
        path: 'reward',
        component: r(YIR2019Reward),
        name: 'yir_2019_reward',
      },
      {
        path: 'share/:id',
        component: r(YIR2019Share),
        name: 'yir_2019_share',
      },
      {
        path: 'off',
        component: r(YIR2019Off),
        name: 'yir_2019_off',
      },
    ],
  },
  {
    path: '/roda-rejeki/',
    component: r(SpinWin),
    children: [
      {
        path: '',
        component: r(SpinWinIndex),
        name: 'spinwin_index',
      },
    ],
  },
  {
    path: '/faq',
    component: r(FAQ),
    name: 'faq_index',
  },
  {
    path: '/ulasan-belanja/:id',
    component: r(UlasanBelanja),
    name: 'ulasan_belanja_index',
  },
  {
    path: '/mitra-puzzle-miliarder/',
    component: r(MitraPuzzleMiliarder),
    children: [
      {
        path: '',
        component: r(MitraPuzzleMiliarderIndex),
        name: 'mitra_puzzle_miliarder_index',
      },
      {
        path: 'onboarding',
        component: r(MitraPuzzleMiliarderOnboarding),
        name: 'mitra_puzzle_miliarder_onboarding',
      },
      {
        path: 'tnc',
        component: r(MitraPuzzleMiliarderTnc),
        name: 'mitra_puzzle_miliarder_tnc',
      },
      {
        path: 'history',
        component: r(MitraPuzzleMiliarderHistory),
        name: 'mitra_puzzle_miliarder_history',
      },
    ],
  },
  {
    path: '/ubah-nomor',
    component: r(UbahNomor),
    children: [
      {
        path: '',
        component: r(UbahNomorIndex),
        name: 'ubah_nomor_handphone_index',
      },
      {
        path: 'verifikasi',
        component: r(VerificationForm),
        name: 'ubah_nomor_verification',
      },
      {
        path: 'foto',
        component: r(CameraOverlayCapture),
        name: 'ubah_nomor_foto',
      },
      {
        path: 'otp',
        component: r(OTPVerificationForm),
        name: 'otp_form_verification',
      },
      {
        path: 'mandiri',
        component: r(CurrentNumberConfirmation),
        name: 'current_number_confirmation',
      },
      {
        path: 'new-otp',
        component: r(PhoneNumberVerification),
        name: 'new_input_otp',
      },
      {
        path: 'nomor-baru',
        component: r(InputNewNumber),
        name: 'input_new_number',
      },
      {
        path: 'unbinding-consent',
        component: r(UnbindingConsent),
        name: 'unbinding_consent',
      },
    ],
  },
  {
    path: '/b2b/',
    component: r(B2B),
    children: [
      {
        path: '',
        component: r(B2BIndex),
        name: 'mitrab2b_index',
      },
      {
        path: 'bantuan',
        component: r(B2BBantuan),
        name: 'mitrab2b_bantuan',
      },
      {
        path: 'products/:id',
        component: r(B2BProductDetail),
        name: 'mitrab2b_product_detail',
      },
    ],
  },
  // THIS ROUTE SHOULD ALWAYS BE PLACED AT THE BOTTOM OF THIS LIST FOR 404 REDIRECT
  {
    path: '*',
    redirect: to => {
      return {
        path: '/404',
        query: {
          from: encodeURI(to.fullPath),
        },
      };
    },
  },
];

export function createRouter() {
  return new Router({
    mode: 'history',
    routes,
  });
}
